import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Modal,
  Divider,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  modalStyle,
  surveyHeaderText,
  surveyText,
  contentStart,
  svgStyle,
  contentSpaceBetween,
  contentStartRow,
  buttonStyle,
  AnswerText,
  marginLeft,
} from "../assets/styles/sxStyles";
import WarningIcon from "./../assets/icons/Warning.svg";
import CustomButton from "./CustomButton";

const CustomModal = ({ enabled, handleClose, handleAccept }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(enabled);
  }, [enabled]);

  return (
    <Modal
      open={open}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Grid container sx={{ ...modalStyle, width: "50em", maxWidth: "80vw" }}>
        <Grid container sx={contentStart} gap={"1.05rem"}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...contentStartRow, ...surveyHeaderText }}
              gap={"0.5rem"}
            >
              <img src={WarningIcon} alt="Warning Icon" style={svgStyle} />
              <b>Important Notice</b>
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Typography sx={surveyText}>
              You're about to start your AI-powered virtual interview with
              Pyxis—an easy, seamless way to share your thoughts.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={surveyText}>What to Expect:</Typography>

            <List disablePadding sx={marginLeft}>
              <ListItem>
                <ListItemText
                  secondary="Convenient & Effortless: Simply speak your answers
              naturally, just like a regular conversation."
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  secondary="Empathetic &
              Thoughtful: Your perspective matters, and Pyxis ensures it's
              heard."
                />
              </ListItem>
            </List>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={surveyText}>
              When you're ready, click below to begin. We appreciate your time!
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sx={contentSpaceBetween}>
            <CustomButton
              text={"Go Back"}
              variant={"outlined"}
              icon={""}
              disabled={false}
              color={"gray"}
              handleclick={handleClose}
            />

            {/* <CustomButton
              text={"Continue to Virtual Interview"}
              variant={"contained"}
              icon={""}
              disabled={false}
              color={"primary"}
              handleclick={handleAccept}
            /> */}

            <Button
              variant="contained"
              color={"primary"}
              sx={buttonStyle}
              onClick={handleAccept}
              disabled={false}
              size="small"
            >
              <Typography sx={AnswerText}>
                Continue to Virtual Interview
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default CustomModal;
